import api, { Header } from '../../base';
import {
  AllegroCreateOrUpdateImpliedWarrantyRequest,
  AllegroImpliedWarranties,
  AllegroFullImpliedWarranty,
} from './impliedWarrantyTypes';
import { mockAllegroImpliedWarranty, mockGetAllegroImpliedWarranties } from './impliedWarrantyMocks';

const IMPLIED_WARRANTIES_PATH = 'allegro-api/after-sales-service-conditions/implied-warranties';

export async function getAllegroImpliedWarranties(
  marketplaceCode: string,
  offset: number = 0,
  limit: number = 60,
  signal?: AbortSignal,
): Promise<AllegroImpliedWarranties> {
  const response = await api.get<AllegroImpliedWarranties>(IMPLIED_WARRANTIES_PATH, {
    headers: {
      [Header.X_ESHOP_CODE]: marketplaceCode,
      [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
    },
    params: { offset, limit },
    signal,
  });

  return response.data;
}

api.mock
  .onGet('allegro-api/after-sales-service-conditions/implied-warranties')
  .reply(200, mockGetAllegroImpliedWarranties);

export async function getAllegroImpliedWarranty(
  marketplaceCode: string,
  id: string,
  signal?: AbortSignal,
): Promise<AllegroFullImpliedWarranty> {
  const response = await api.get<AllegroFullImpliedWarranty>(
    `${IMPLIED_WARRANTIES_PATH}/${id}`,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
      },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onGet(/allegro-api\/after-sales-service-conditions\/implied-warranties\/.+/)
  .reply(200, mockAllegroImpliedWarranty);

export async function createAllegroImpliedWarranty(
  marketplaceCode: string,
  payload: AllegroCreateOrUpdateImpliedWarrantyRequest,
  signal?: AbortSignal,
): Promise<AllegroFullImpliedWarranty> {
  const response = await api.post<AllegroFullImpliedWarranty>(
    IMPLIED_WARRANTIES_PATH,
    payload,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
        [Header.CONTENT_TYPE]: 'application/vnd.allegro.public.v1+json',
      },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onPost('allegro-api/after-sales-service-conditions/implied-warranties')
  .reply(200, mockAllegroImpliedWarranty);

export async function updateAllegroImpliedWarranty(
  marketplaceCode: string,
  id: string,
  payload: AllegroCreateOrUpdateImpliedWarrantyRequest,
  signal?: AbortSignal,
): Promise<AllegroFullImpliedWarranty> {
  const response = await api.put<AllegroFullImpliedWarranty>(
    `${IMPLIED_WARRANTIES_PATH}/${id}`,
    payload,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
        [Header.CONTENT_TYPE]: 'application/vnd.allegro.public.v1+json',
      },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onPut(/allegro-api\/after-sales-service-conditions\/implied-warranties\/.+/)
  .reply(200, mockAllegroImpliedWarranty);
